import axios from 'axios';
import store from '../../store';
import configuration from '../../envConfig';
import queryString from 'query-string';
import { isRotaAberta } from 'login/helper';

const prefixoRequest = configuration.urlApi;
const prefixoRequestArq = configuration.urlArq;

const config = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};

axios.defaults.headers = {
    'Cache-Control': 'no-store',
    'Pragma': 'no-cache',
    'Expires': '0',
};

const getUrlRequest = url => {
    if (url.startsWith('https://')) return url;
    if (url.includes('SagService')) return prefixoRequestArq + url;

    return prefixoRequest + url;
}
const getHeaders = () => {

    if (!localStorage.getItem('userId')) {
        let userIdStorage = (new Date()).getTime() + '-' + Math.random().toString(36).substring(2);
        localStorage.setItem('userId', userIdStorage.substring(0, 25));
    }
    
    if (!sessionStorage.getItem('sessionId')) {
        const sessionIdStorage = (new Date()).getTime() + '-' + Math.random().toString(36).substring(2);
        sessionStorage.setItem('sessionId', sessionIdStorage.substring(0, 25));
    }

    const forceLogout = (store.getState().session.usuario.token && !localStorage.getItem('ifs_auth'));
    const rotaAberta = isRotaAberta(window.location.hash);
    if (forceLogout && !rotaAberta) {
        store.dispatch({ type: 'USUARIO_DESLOGADO' });
    }

    const token = store.getState().session.usuario.token;
    const miToken = store.getState().session.miToken;
    const userId = localStorage.getItem('userId');
    const sessionId = sessionStorage.getItem('sessionId');

    return {
        ...config,
        ...(token && { Authorization: 'Bearer ' + token, miToken: miToken }),
        userId: userId,
        sessionId: sessionId,
        miVersion: window.miVersion,
        miReferer: window.location.href,
        miPlatform: window.miPlatform
    };
    
};

const resolveUrl = (url) => {
    if (typeof url === 'string') {
        return { path: getUrlRequest(url) }
    }
    if (url.params) {
        url.path += url.path.indexOf('?') > -1 ? '&' : '?';
    }
    for (var key in url.params) {
        if (url.params.hasOwnProperty(key)) {
            if (Array.isArray(url.params[key])) {
                let a = url.params[key];
                for (let i = 0; i < a.length; i++) {
                    url.path += key + '=' + a[i] + '&';
                }
            } else {
                url.path += key + '=' + url.params[key] + '&';
            }
        }
    }
    let path = url.path;
    if (url.path.substr(url.path.length - 1) === '&') {
        path = url.path.slice(0, -1);
    }
    return { path: getUrlRequest(path), params: url.params };
};

/* ------- GET ------- */

export const getSeguroPromise = (path, params) => {
    const uri = getUrlRequest(path);
    return axios.get(uri, { headers: getHeaders(), params });
};

export const getSeguro = (dispatch, url, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);

    return axios.get(urlObj.path, { headers: getHeaders() })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => {
            dispatch(acaoFalha(falha))
        });
};

export const getSeguroCache = (dispatch, url, acaoSucesso, acaoFalha, cacheName, expiration) => {
    
    if (window.caches) {
        return caches.open(cacheName ? cacheName : "default").then(async (cache) => {
            const response = await cache.match(url);

            if (response && response.headers.get("timeExpiration") &&
                    parseInt(response.headers.get("timeExpiration")) > (new Date().getTime())) {
                console.debug("Retornando do cache pra URL ", url);
                let text = await response.text();
                return dispatch(acaoSucesso(JSON.parse(text)));
            }

            const urlObj = resolveUrl(url);
            
            return axios.get(urlObj.path, { headers: getHeaders() })
                .then(axiosResponse => {
                    if (axiosResponse.status === 200) {
                        let timeExpiration = new Date().getTime() + (expiration ? expiration : configuration.timeoutCache);
                        const response = new Response(JSON.stringify(axiosResponse.data), { headers: new Headers({
                                "timeExpiration": timeExpiration
                            })});
                        cache.put(url, response);
                    }
                    return dispatch(acaoSucesso(axiosResponse.data));
                })
                .catch(async falha => {
                    if (response) {
                        console.debug("Retornando do cache pra URL por ERRO ", url);
                        let text = await response.text();
                        return dispatch(acaoSucesso(JSON.parse(text)));
                    } else {
                        dispatch(acaoFalha(falha))
                    }
                });

        })
        .catch((error) => {
            console.error("Erro ao chamar método get pelo cache:", error);
            return getSeguro(dispatch, url, acaoSucesso, acaoFalha);
        });
    } else {
        console.warn("Navegador não suporta utilização de cache");
        return getSeguro(dispatch, url, acaoSucesso, acaoFalha);
    }
   
}

export const getSeguroCustom = (dispatch, url, httpOptions, acaoSucesso, acaoFalha) => {
    const axiosOptions = {
        ...httpOptions,
        headers: getHeaders(),
    };

    const urlObj = resolveUrl(url);
    return axios.get(urlObj.path, axiosOptions)
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};

export const getSeguroDownloadPdf = (dispatch, url, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);

    // necessário para PDF
    const httpOptions = {
        responseType: 'blob'
    };

    const axiosOptions = {
        ...httpOptions,
        headers: getHeaders(),
    };

    return axios.get(urlObj.path, { headers: axiosOptions })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => {
            dispatch(acaoFalha(falha))
        });
};

/* O Axios realiza uma conversao do retorno para inteiro.
   Como o protocolo da CTC é um inteiro maior do que o Javascript suporta, surgem erros.
   Esse getSeguro desabilita a transformação.

https://stackoverflow.com/questions/57925442/how-to-return-18-character-string-response-from-an-axios-post-request  */
export const getSeguroRaw = (dispatch, url, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);

    return axios.get(urlObj.path, {
        transformResponse: (response => response),
        headers: getHeaders()
    })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};

// PDF
export const getSeguroPdf = (dispatch, url, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);
    return axios.get(urlObj.path, { headers: getHeaders(), responseType: 'arraybuffer', params: urlObj.params })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};


/* ------- POST ------- */

export const postSeguroPromiseWithCustomHeaders = (path, data, customHeaders) => {
    const uri = getUrlRequest(path);
    //const uri = prefixoRequestArq + path;
    let headers = getHeaders();
    if (customHeaders)
        headers = { ...headers, ...customHeaders };
    return axios.post(uri, data, { headers: headers });

}

export const postSeguroPromise = (path, data, params) => {
    const uri = getUrlRequest(path);
    return axios.post(uri, data, { headers: getHeaders(), ...params });
};

export const postSeguro = (dispatch, path, data, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(path);

    return axios.post(urlObj.path, data, { headers: getHeaders() })
        .then(response => dispatch(acaoSucesso(response.data, response.status)))
        .catch(falha => dispatch(acaoFalha(falha)));
};

export const postUploadProgress = (dispatch, path, data, acaoSucesso, acaoFalha, progressoCallback) => {
    const uri = getUrlRequest(path);

    return axios.post(uri, data, {
        headers: getHeaders(), onUploadProgress: function (progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            progressoCallback(percentCompleted)
        }
    })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));

};

// PDF
export const postSeguroPdf = (dispatch, url, data, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);

    return axios.post(urlObj.path, data, { headers: getHeaders(), responseType: 'arraybuffer' })
        .then(response => { dispatch(acaoSucesso(response.data)) })
        .catch(falha => { dispatch(acaoFalha(falha)) });
};

export const postSeguroPdfUrlEncoded = (dispatch, path, data, acaoSucesso, acaoFalha) => {
    const uri = getUrlRequest(path);
    let headers = getHeaders();
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
    headers['Accept'] = 'text/pdf,application/json';

    let formatedData = queryString.stringify(data);
    return axios.post(uri, formatedData, { headers, responseType: 'arraybuffer' })
        .then(response => { dispatch(acaoSucesso(response.data)) })
        .catch(falha => { dispatch(acaoFalha(falha)) });

};


/* ------- PUT ------- */

export const putSeguroPromise = (path, data) => {
    const uri = getUrlRequest(path);

    return axios.put(uri, data, { headers: getHeaders() });
};

export const putSeguro = (dispatch, url, data, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);
    return axios.put(urlObj.path, data, { headers: getHeaders(), params: urlObj.params })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};

/* ------- PATCH ------- */

export const patchSeguroPromise = (path, data) => {
    const uri = getUrlRequest(path);

    return axios.patch(uri, data, { headers: getHeaders() });
};

export const patchSeguro = (dispatch, url, data, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);
    return axios.patch(urlObj.path, data, { headers: getHeaders(), params: urlObj.params })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};


/* ------- DELETE ------- */

export const deleteSeguroPromise = (path, params) => {
    const uri = getUrlRequest(path);

    return axios.delete(uri, { headers: getHeaders(), params });
};

export const deleteSeguro = (dispatch, url, acaoSucesso, acaoFalha) => {
    const urlObj = resolveUrl(url);

    return axios.delete(urlObj.path, { headers: getHeaders(), params: urlObj.params })
        .then(response => dispatch(acaoSucesso(response.data)))
        .catch(falha => dispatch(acaoFalha(falha)));
};
/*------- requests para ambiente externo al gateway ---*/

export const getInternalResource = (path) => {
    return axios.get(path, { responseType: 'arraybuffer' });
}
